// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"435":"css/app.6778","1796":"css/admin-app.6778"}[chunkId] + ".css";
};